import React from "react";
import {
  Typography,
  Grid,
  InputLabel,
  TextField,
  Button,
  Autocomplete,
  CircularProgress,
  Stack,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import InfiniteTable from "../../../components/InfiniteTable/InfiniteTable";

const useStyles = makeStyles((theme) => ({
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
  paper: {
    marginTop: theme.spacing(5),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  button: {
    marginLeft: theme.spacing(1),
  },
}));

const ReceiptViewer = (props) => {
  const {
    columns,
    receipts,
    receiptSelected,
    pricingType,
    receiptLines,
    receiptLinesLoaded,
    handleChangeReceipt,
    handleChangePricingType,
    handleClickOldExportViewer,
  } = props;

  const classes = useStyles();

  return (
    <div className={classes.paper}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12}>
          <Typography component="h4" style={{ textAlign: "center" }}>
            Select a receipt to view the information saved to the system
          </Typography>
        </Grid>
        <Grid item xs={12} sm={12}>
          <InputLabel shrink id="stripeLabel">
            Pricing type
          </InputLabel>
          <Stack direction="row" spacing={1}>
            <Button
              style={{ marginBottom: 10 }}
              variant="contained"
              color={pricingType === "shelf" ? "primary" : "inherit"}
              onClick={handleChangePricingType("shelf")}
              className={classes.button}
            >
              Shelf
            </Button>
            <Button
              style={{ marginBottom: 10 }}
              variant="contained"
              color={pricingType === "contract" ? "primary" : "inherit"}
              onClick={handleChangePricingType("contract")}
              className={classes.button}
            >
              Contract
            </Button>
          </Stack>
        </Grid>
        {receipts.length ? (
          <Grid item xs={12} sm={12}>
            <InputLabel shrink id="stripeLabel">
              Receipts
            </InputLabel>
            <Autocomplete
              fullWidth
              disablePortal
              size="small"
              name="receipts"
              options={receipts}
              getOptionLabel={(option) =>
                `${option.description} (${option.id})${
                  option.user_uploaded ? ` - user uploaded` : ``
                }`
              }
              renderInput={(params) => (
                <TextField {...params} size="small" variant="standard" />
              )}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              onChange={(e, value) => handleChangeReceipt(e, value)}
              value={receiptSelected}
            />
          </Grid>
        ) : (
          <Grid item xs={12} sm={12}>
            <InputLabel shrink id="stripeLabel">
              Receipts
            </InputLabel>
            <CircularProgress />
          </Grid>
        )}

        {receiptSelected !== null && receiptLinesLoaded ? (
          receiptLines.length ? (
            <>
              <Grid item xs={12} style={{ textAlign: "right" }}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleClickOldExportViewer}
                >
                  Export to Old Format
                </Button>
              </Grid>
              <Grid item xs={12}>
                <InfiniteTable
                  {...props}
                  apiep={null}
                  columns={columns}
                  data={receiptLines}
                  dataMapByColumn="id"
                  deletable={false}
                  editable={null}
                  filterable={true}
                  label={`Receipt information - Total: $${receiptSelected.total}`}
                  fetchingModal={null}
                />
              </Grid>
            </>
          ) : (
            <Grid item xs={12}>
              <Typography
                component="h4"
                style={{ textAlign: "center", color: "red" }}
              >
                The selected receipt does not have information saved in the
                system
              </Typography>
            </Grid>
          )
        ) : (
          <></>
        )}
      </Grid>
    </div>
  );
};

export default ReceiptViewer;
